import React from 'react';
import './GoToSupport.scss';
import IntlMessages from 'utils/IntlMessages';

export const GoToSupportBtn = () => (
  <a
    href="https://mk21support.cencoapps.com/?lang=es_ES"
    target="_blank"
    rel="noopener noreferrer"
    className="go-to-ai-btn"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 13 13"
      fill="none"
    >
      <g clipPath="url(#clip0_209_4)">
        <path
          d="M4.0625 7.3125H3.65625C2.75869 7.3125 2.03125 8.04121 2.03125 8.94055V10.5595C2.03125 11.4585 2.75869 12.1875 3.65625 12.1875H4.0625C4.51115 12.1875 4.875 11.8229 4.875 11.3735V8.12652C4.875 7.67686 4.51115 7.3125 4.0625 7.3125ZM9.34375 7.3125H8.9375C8.48885 7.3125 8.125 7.67686 8.125 8.12652V11.3735C8.125 11.8229 8.48885 12.1875 8.9375 12.1875H9.34375C10.2413 12.1875 10.9688 11.4585 10.9688 10.5595V8.94055C10.9688 8.04146 10.2413 7.3125 9.34375 7.3125ZM6.5 0.8125C2.86686 0.8125 0.116035 3.83729 0 7.3125V10.1562C0 10.3807 0.181797 10.5625 0.40625 10.5625H0.8125C1.03695 10.5625 1.21875 10.3807 1.21875 10.1562V7.3125C1.21875 4.40096 3.58846 2.03633 6.5 2.03582C9.41154 2.03633 11.7812 4.40096 11.7812 7.3125V10.1562C11.7812 10.3807 11.963 10.5625 12.1875 10.5625H12.5938C12.8182 10.5625 13 10.3807 13 10.1562V7.3125C12.884 3.83729 10.1331 0.8125 6.5 0.8125Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_209_4">
          <rect width="13" height="13" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <span className="go-to-ai-btn-text">
      <IntlMessages id="contact with support" />
    </span>
  </a>
);
